<template>
  <div class="w-full">

    <div class="w-full flex items-center justify-between">
      <b class="text-2xl">Lietajúci burger</b>
      <Button @click="saveAction" :loading="saveing" label="Uložiť" class="w-[230px] mt-4"/>
    </div>

    <hr class="my-4">

    <div v-if="loading">
      Loading ...
    </div>

    <template v-else>

      <AdminBurgerFlyPart v-for="(_,i) in contentStore.flyParts"
                          :key="i"
                          v-model="contentStore.flyParts[i]"
      />

    </template>


  </div>
</template>

<script setup>

import {ref, onMounted, nextTick, onUnmounted, watch} from 'vue'
import Supabase from "@/utils/Supabase.js";
import AdminBurgerFlyPart from "@/components/views/AdminBurgerFlyPart.vue";
import useContentStore from "@/stores/contentStore.js";

const contentStore = useContentStore()

const saveing = ref(false)
const saveAction = async () => {
  saveing.value = true

  const updateData = contentStore.flyParts.map(part => ({
    id: part.id,
    name_sk: part.name_sk,
    name_en: part.name_en,
    name_de: part.name_de,
    name_cz: part.name_cz,
  }))

  const {data, error} = await Supabase.from('v2_Hajcer_App_Products_Fly_Parts').upsert(updateData)
  if (error) {
    alert('Error')
    console.error(error)
  } else {
    alert('Saved')
    await contentStore.loadFlyParts()
  }
  saveing.value = false
}

</script>